import React, { type ReactElement, forwardRef, useMemo } from 'react'
import { MenuItem, ListItemIcon, ListItemText, type SxProps, type Theme } from '@mui/material'
import { NavLink, type NavLinkProps } from 'react-router-dom'

interface MenuItemNavLinkProps {
  primary?: string
  to: string
  icon?: React.ReactElement
  className?: string
  end?: boolean
  onClick?: () => void
  sx?: SxProps<Theme>
  endComponent?: React.ReactElement
}

const MenuItemNavLink = ({
  icon,
  primary,
  to,
  className,
  onClick,
  end = false,
  sx,
  endComponent,
  ...rest
}: MenuItemNavLinkProps): ReactElement => {
  const renderLink = useMemo(
    () =>
      forwardRef<any, Omit<NavLinkProps, 'to'>>(({ className: defaultStyling, ...itemRest }, ref) => (
        <NavLink
          to={to}
          ref={ref}
          className={({ isActive }) => `${defaultStyling} ${isActive ? 'Mui-selected' : ''}`}
          {...itemRest}
          end={end}
        />
      )),
    [to, end],
  )

  return (
    <MenuItem component={renderLink} onClick={onClick} sx={sx} className={className} {...rest}>
      {icon && <ListItemIcon>{icon}</ListItemIcon>}
      {primary && <ListItemText primary={primary} />}
      {endComponent && endComponent}
    </MenuItem>
  )
}

MenuItemNavLink.displayName = 'MenuItemNavLink'

export { MenuItemNavLink }
